import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-gold/15 bg-ink" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-4 md:py-20">
        <div className="md:col-span-2">
          <div className="flex w-fit flex-col gap-2.5">
            <div className="flex items-center gap-3">
              <img
                src="/brand/zaichauffer-emblema-trasparente.png"
                alt=""
                className="h-11 w-11 object-contain md:h-12 md:w-12"
              />
              <span className="flex items-center justify-center border-[1.5px] border-gold px-2.5 py-1">
                <span className="font-serif text-xl font-semibold tracking-[0.14em] text-bone">ZAI</span>
              </span>
              <span className="font-serif text-2xl tracking-[0.2em] text-bone">CHAUFFER</span>
            </div>
            <div className="flex flex-col gap-2">
              <div className="h-px w-full bg-gold/50" />
              <span className="flex justify-between text-[8px] uppercase text-gold/90">
                {"Private Chauffeur Service".split("").map((ch, i) => (
                  <span key={i}>{ch === " " ? "\u00A0" : ch}</span>
                ))}
              </span>
            </div>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-mute">
            Servizio di autista privato per trasferimenti in tutta Italia, gestito direttamente da Khalid El
            Aissaoui.
          </p>
        </div>

        <div>
          <p className="label-cap mb-6">Menu</p>
          <ul className="space-y-3 text-sm text-bone/70">
            <li>
              <Link data-testid="footer-link-home" to="/" className="transition-colors duration-300 hover:text-gold">Home</Link>
            </li>
            <li>
              <Link data-testid="footer-link-chi-siamo" to="/chi-siamo" className="transition-colors duration-300 hover:text-gold">Chi siamo</Link>
            </li>
            <li>
              <Link data-testid="footer-link-servizi" to="/servizi" className="transition-colors duration-300 hover:text-gold">Servizi</Link>
            </li>
            <li>
              <Link data-testid="footer-link-contatti" to="/contatti" className="transition-colors duration-300 hover:text-gold">Contatti</Link>
            </li>
            <li>
              <Link data-testid="footer-link-preventivo" to="/richiedi-preventivo" className="transition-colors duration-300 hover:text-gold">Richiedi preventivo</Link>
            </li>
            <li>
              <Link data-testid="footer-link-privacy" to="/privacy-policy" className="transition-colors duration-300 hover:text-gold">Privacy Policy</Link>
            </li>
            <li>
              <Link data-testid="footer-link-cookie" to="/cookie-policy" className="transition-colors duration-300 hover:text-gold">Cookie Policy</Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="label-cap mb-6">Contatti</p>
          <p className="text-sm text-bone/70">Khalid El Aissaoui</p>
          <p className="mt-3 text-sm text-bone/70">
            <a
              data-testid="footer-email"
              href="mailto:info@zaichauffeur.it"
              className="transition-colors duration-300 hover:text-gold"
            >
              info@zaichauffeur.it
            </a>
          </p>
          <p className="mt-2 text-sm text-bone/70">
            <a
              data-testid="footer-phone"
              href="tel:+393208189469"
              className="transition-colors duration-300 hover:text-gold"
            >
              +39 3208189469
            </a>
          </p>
          <Link
            data-testid="footer-cta-preventivo"
            to="/richiedi-preventivo"
            className="lux-link mt-8"
          >
            Richiedi un preventivo
          </Link>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-6 text-[11px] tracking-wide text-mute sm:flex-row sm:items-center sm:justify-between">
          <span data-testid="footer-copyright">
            © 2026 Zaichauffer – Khalid El Aissaoui. All rights reserved. · P.IVA 04197620364
          </span>
          <span className="label-cap !text-[9px]">
            Professionalità · Puntualità · Discrezione · Comfort
          </span>
        </div>
      </div>
    </footer>
  );
}
